/*
 *
 * OtpErrorToast
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 20-Jan-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  wrongCode: (
    <PortalMessage
      id='t.app.registration.toast.otpCodeWrong'
      defaultMessage='Il codice inserito non è corretto. Riprova.'
    />
  ),
  wrongDoubleCode: (
    <PortalMessage
      id='t.app.error.toast.doubleOtpCodeWrong'
      defaultMessage='I codici inseriti non sono corretti. Riprova.'
    />
  ),
  lastAttemptAvailable: (
    <PortalMessage
      id='t.app.error.toast.lastAttemptAvailable'
      defaultMessage='Il codice inserito non è corretto. Hai ancora <b>1 tentativo</b> a disposizione.'
    />
  ),
  lastAttemptAvailableDouble: (
    <PortalMessage
      id='t.app.error.toast.lastAttemptAvailableDouble'
      defaultMessage='I codici inseriti non sono corretti. Hai ancora <b>1 tentativo</b> a disposizione.'
    />
  ),
  newOtpGenerated: (
    <PortalMessage
      id='t.app.error.toast.sentNewOTPCode'
      defaultMessage='Ti abbiamo inviato un nuovo codice.'
    />
  ),
  newDoubleOtpGenerated: (
    <PortalMessage
      id='t.app.error.toast.sentNewDoubleOTPCode'
      defaultMessage='Ti abbiamo inviato dei nuovi codici.'
    />
  )
}

export default formattedMessage
